module.exports = __webpack_public_path__ + "static/media/connected.4c22dc0.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/connected.ogg
// module id = G72S
// module chunks = 1